import { Component, Input } from '@angular/core';
import { MemberDto, MemberSearchResultListDto, TicketModeEnum, WorkflowDto } from '../../../../../service/dto';
import { PolicyDto } from '../../../../../service/dto-insurance';
import { Router } from '@angular/router';
import { HttpTicketService } from '../../../../../service/http-ticket.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TicketPickerComponent } from '../ticket-picker/ticket-picker.component';


class WrapperMemberSearchResultDto {
	payload!: MemberDto;
	policies!: WrapperMemberSearchResultPolicyDto[]
	expanded!: boolean;
	checked = false;
	indeterminate = false;
	setOfCheckedId = new Set<number>();
}
class WrapperMemberSearchResultPolicyDto {
	payload!: PolicyDto;
	selected!: boolean;
}


@Component({
	selector: 'app-ticket-member-search-by-policy',
	standalone: false,
	templateUrl: './ticket-member-search-by-policy.component.html',
	styleUrl: './ticket-member-search-by-policy.component.scss'
})
export class TicketMemberSearchByPolicyComponent {
	@Input() loading!: boolean;
	@Input() ticketMode!: TicketModeEnum;
	@Input() workflows: WorkflowDto[] = [];
	_data?: WrapperMemberSearchResultDto[];

	constructor(private router: Router, private ticketService: HttpTicketService, private modalService: NzModalService) {

	}

	@Input()
	set data(input: MemberSearchResultListDto | undefined) {
		if (input == undefined) {
			this._data = undefined;
			return;
		}
		this._data = input.results.map(item => {
			return {
				payload: item.member,
				policies: item.member.policies.map(i => { return { payload: i, selected: false } }),
				checked: false,
				indeterminate: false,
				setOfCheckedId: new Set<number>(),
				expanded: true
			};
		});
	}

	canCreateTicket(input: WrapperMemberSearchResultDto): boolean {
		return input.setOfCheckedId.size > 0;
	}
	startTicket(input: WrapperMemberSearchResultDto) {
		const selectedPolicyIds = Array.from(input.setOfCheckedId);

		if (selectedPolicyIds.length == 0) {
			return;
		} else if (selectedPolicyIds.length == 1) {
			this.router.navigate(['/ticket', this.ticketMode, 'policy', selectedPolicyIds[0]]);
		} else {
			const [first, ...rest] = selectedPolicyIds;

			this.router.navigate(['/ticket', this.ticketMode, 'policy', first]);
			for (let selectedPolicyId of rest) {
				window.open(this.router.serializeUrl(this.router.createUrlTree(['/ticket', this.ticketMode, 'policy', selectedPolicyId])), '_blank');
			}
		}
	}
	onAllChecked(member: WrapperMemberSearchResultDto, selected: boolean) {
		member.policies.forEach(item => this.updateCheckedSet(member, item, selected));
		this.refreshCheckedStatus(member);
	}
	onItemChecked(member: WrapperMemberSearchResultDto, policies: WrapperMemberSearchResultPolicyDto, checked: boolean): void {
		this.updateCheckedSet(member, policies, checked);
		this.refreshCheckedStatus(member);
	}
	updateCheckedSet(wrapper: WrapperMemberSearchResultDto, policies: WrapperMemberSearchResultPolicyDto, checked: boolean): void {
		if (checked) {
			wrapper.setOfCheckedId.add(policies.payload.id!);
		} else {
			wrapper.setOfCheckedId.delete(policies.payload.id!);
		}
	}
	refreshCheckedStatus(member: WrapperMemberSearchResultDto): void {
		member.checked = member.policies.every(item => member.setOfCheckedId.has(item.payload.id!));
		member.indeterminate = member.policies.some(item => member.setOfCheckedId.has(item.payload.id!)) && !member.checked;
	}

	isRecent(dateValue: string | Date | null | undefined): boolean {
		if (!dateValue) {
			return false;
		}

		const date = new Date(dateValue);
		const now = new Date();

		const diffMs = now.getTime() - date.getTime();
		const thirtyDaysMs = 30 * 24 * 60 * 60 * 1000;

		return diffMs < thirtyDaysMs;
	}
}
